// extracted by mini-css-extract-plugin
export var productImage = "_pd-1";
export var viewLink = "_pd-2";
export var wishlistItem = "_pd-0";